import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const postContact = (data) => axios.post(`${API}/contact`, data);
export const subscribeNewsletter = (email) => axios.post(`${API}/newsletter`, { email });
